document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.filter-btn');
    const items = document.querySelectorAll('.referenz-item');

    buttons.forEach(button => {
        button.addEventListener('click', function () {
            // 1. Aktiven Button-Style wechseln
            buttons.forEach(btn => btn.classList.remove('active'));
            this.classList.add('active');

            const filterValue = this.getAttribute('data-filter');

            // 2. Elemente filtern
            items.forEach(item => {
                const itemCategory = item.getAttribute('data-kat');

                if (filterValue === 'all' || itemCategory === filterValue) {
                    item.style.display = 'block'; // Oder 'flex', je nach deinem CSS Layout
                } else {
                    item.style.display = 'none';
                }
            });
        });
    });
});